import EngineWidgetModal from './engine-widget-modal';


export default class EngineWidgetPackages extends EngineWidgetModal {
    static _formatDate(input) {
        if (['', undefined].includes(input)) {
            return undefined;
        }
        return input.split('/').reverse().join('-');
    }

    _prepareInitialData() {
        this._form = this._formClone;
        this._urlPackage = this._trigger.dataset.url;
        this._codpromo = this._trigger.dataset.codpromo;
        this._typePackage = this._trigger.dataset.type;

        if (this._typePackage === 'DP') {
            this._form.classList.add('roi-search-engine__form--daypass');
            this._form.querySelector('.js-roicalendar-checkout').remove();
        }

        if (this._urlPackage) {
            const obj = this;
            this._form.onsubmit = function () {
                let codPromo = this.querySelector('input[name=codpromo]').value;
                const entrada = this.querySelector('input[name=entrada]'),
                    salida = this.querySelector('input[name=salida]');

                if (!codPromo) { codPromo = obj._codpromo; }

                obj._urlPackage = `${obj._urlPackage}&fe=${obj.constructor._formatDate(entrada.value)}`;

                if (obj._typePackage !== 'DP') {
                    obj._urlPackage = `${obj._urlPackage}&fs=${obj.constructor._formatDate(salida.value)}`;
                }

                if (codPromo) { obj._urlPackage = `${obj._urlPackage}&cp=${codPromo}`; }

                window.open(obj._urlPackage, '_self');
                return false;
            };
        }
        return {
            ...super._prepareInitialData(),
            codpromo: this._trigger.dataset.codpromo
        };
    }
}
